import { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import formStyles from '../../../styles/forms.module.scss';
import s from './WindFacilityForm.module.scss';
import {
  TextInput,
  AccessibleDatepickerInput,
  AddressInputFields,
  CommonFacilityFields,
} from '../../../common/FormFields';
import RemoveFacilityButton from '../FacilityButtons/RemoveFacilityButton';
import type { BioMasseFacilityField } from '../../../domain/facility';
import type { BaseFacilityFormProps } from './facilityFormTypes';

const NAME_PREFIX_MIN = 'bioMasseFacilityData' as const;

function BioMasseFacilityForm({
  id,
  index,
  deleteFacility,
  values,
  form,
}: BaseFacilityFormProps) {
  const namePrefix = `${NAME_PREFIX_MIN}[${index}]`;
  const fieldName = (field: BioMasseFacilityField) => `${namePrefix}.${field}`;

  const firstInputRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (index !== 0 && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [index]);

  return (
    <div className={formStyles.inputGroup}>
      {index !== 0 && (
        <>
          <hr className={formStyles.separator} />
          <div className={s.removeWrapper}>
            <RemoveFacilityButton onClick={() => deleteFacility(index)} />
          </div>
        </>
      )}
      <fieldset>
        <legend className={formStyles.caption}>
          <FormattedMessage id="offerWizard.StepFacilityData.technicalDetails" />
        </legend>
        <div ref={firstInputRef} tabIndex={-1}>
          <div data-id={id} className={formStyles.inputPairSingle}>
            <Field
              name={fieldName('generated')}
              component={TextInput}
              labelMsg="offerWizard.StepBioMasseFacilityData.generated.label"
            />
          </div>
        </div>
        <div className={formStyles.inputPairSingle}>
          <Field
            name={fieldName('initialOperation')}
            component={AccessibleDatepickerInput}
            labelMsg="offerWizard.StepBioMasseFacilityData.initialOperation.label"
          />
        </div>
      </fieldset>
      <CommonFacilityFields
        namePrefix={namePrefix}
        facilityValues={values.bioMasseFacilityData?.[index]}
        form={form}
      />
      <div className={formStyles.inputWithVerticalSpacing}>
        <fieldset>
          <legend className={formStyles.caption}>
            <FormattedMessage id="offerWizard.StepWindFacilityData.address" />
          </legend>
          <AddressInputFields namePrefix={namePrefix} isRequired={false} />
        </fieldset>
      </div>
    </div>
  );
}

export default BioMasseFacilityForm;
